export default "/images/BC-Step-1.png?09804358d433d829dc27698eea531fca";